/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShowItemTypeEnum = "contact" | "container" | "shipment" | "vessel" | "voyage" | "%future added value";
export type ContactShowHeroCardQueryVariables = {
    slug: string;
    itemType: ShowItemTypeEnum;
};
export type ContactShowHeroCardQueryResponse = {
    readonly itemShow: {
        readonly title: string;
        readonly " $fragmentRefs": FragmentRefs<"ShowPageItem_data">;
    };
    readonly contactShow: {
        readonly " $fragmentRefs": FragmentRefs<"ContactShowHeroTabBar_contact">;
    };
};
export type ContactShowHeroCardQuery = {
    readonly response: ContactShowHeroCardQueryResponse;
    readonly variables: ContactShowHeroCardQueryVariables;
};



/*
query ContactShowHeroCardQuery(
  $slug: String!
  $itemType: ShowItemTypeEnum!
) {
  itemShow(slug: $slug, type: $itemType) {
    title
    ...ShowPageItem_data
    id
  }
  contactShow(slug: $slug) {
    ...ContactShowHeroTabBar_contact
    id
  }
}

fragment Action_data on Action {
  type
  role
  cta
}

fragment Badge_data on Badge {
  type
}

fragment ContactLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  imageUrl
}

fragment ContactShowHeroTabBar_contact on Contact {
  slug
  canEdit
  registrationStatus
  invitation {
    url
    sentAt
    id
  }
  user {
    createdAt
  }
  revokeAccess
}

fragment ContainerLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
  badge {
    ...Badge_data
  }
}

fragment ItemImage_data on Image {
  url
  alt
  highlight
  shape
  overlay
  overlayIcon
}

fragment KeyField_data on KeyField {
  label
  value {
    key
    ...SemanticString_data
  }
}

fragment LinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
  entitySlug
  ...VoyageLinkCard_data
  ...VesselLinkCard_data
  ...ShipmentLinkCard_data
  ...ContainerLinkCard_data
  ...ContactLinkCard_data
}

fragment SemanticLine_data on SemanticLine {
  parts {
    key
    ...SemanticString_data
  }
}

fragment SemanticString_data on SemanticString {
  text
}

fragment ShipmentLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  badge {
    ...Badge_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  imageUrl
}

fragment ShowPageItem_data on ListItem {
  slug
  title
  itemType
  image {
    ...ItemImage_data
  }
  path
  statuses {
    key
    value {
      ...SemanticString_data
    }
  }
  badges {
    key
    ...Badge_data
  }
  actions {
    key
    ...Action_data
  }
  lines {
    key
    ...SemanticLine_data
  }
  keyFields {
    key
    ...KeyField_data
  }
  linkSets {
    links {
      key
      type
      ...LinkCard_data
    }
  }
  stickyNoteContent
}

fragment VesselLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
}

fragment VoyageLinkCard_data on Link {
  type
  title {
    ...SemanticString_data
  }
  meta {
    ...SemanticString_data
  }
  voyageEta {
    ...SemanticString_data
  }
  voyageEtd {
    ...SemanticString_data
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = {
  "kind": "Variable",
  "name": "slug",
  "variableName": "slug"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "itemType"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = [
  (v2/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v12 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "SemanticLine",
  "kind": "LinkedField",
  "name": "lines",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SemanticString",
      "kind": "LinkedField",
      "name": "parts",
      "plural": true,
      "selections": (v12/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactShowHeroCardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ListItem",
        "kind": "LinkedField",
        "name": "itemShow",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ShowPageItem_data"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contactShow",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContactShowHeroTabBar_contact"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContactShowHeroCardQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ListItem",
        "kind": "LinkedField",
        "name": "itemShow",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "itemType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "alt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "highlight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shape",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "overlay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "overlayIcon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Status",
            "kind": "LinkedField",
            "name": "statuses",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SemanticString",
                "kind": "LinkedField",
                "name": "value",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Badge",
            "kind": "LinkedField",
            "name": "badges",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Action",
            "kind": "LinkedField",
            "name": "actions",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "role",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cta",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyField",
            "kind": "LinkedField",
            "name": "keyFields",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SemanticString",
                "kind": "LinkedField",
                "name": "value",
                "plural": true,
                "selections": (v12/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LinkSet",
            "kind": "LinkedField",
            "name": "linkSets",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Link",
                "kind": "LinkedField",
                "name": "links",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SemanticString",
                    "kind": "LinkedField",
                    "name": "title",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SemanticString",
                    "kind": "LinkedField",
                    "name": "meta",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageUrl",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "entitySlug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SemanticString",
                    "kind": "LinkedField",
                    "name": "voyageEta",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SemanticString",
                    "kind": "LinkedField",
                    "name": "voyageEtd",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Badge",
                    "kind": "LinkedField",
                    "name": "badge",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stickyNoteContent",
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Contact",
        "kind": "LinkedField",
        "name": "contactShow",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canEdit",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registrationStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Invitation",
            "kind": "LinkedField",
            "name": "invitation",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sentAt",
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revokeAccess",
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e95fdb029b3fffd2aa5535c89f8707f",
    "id": null,
    "metadata": {},
    "name": "ContactShowHeroCardQuery",
    "operationKind": "query",
    "text": "query ContactShowHeroCardQuery(\n  $slug: String!\n  $itemType: ShowItemTypeEnum!\n) {\n  itemShow(slug: $slug, type: $itemType) {\n    title\n    ...ShowPageItem_data\n    id\n  }\n  contactShow(slug: $slug) {\n    ...ContactShowHeroTabBar_contact\n    id\n  }\n}\n\nfragment Action_data on Action {\n  type\n  role\n  cta\n}\n\nfragment Badge_data on Badge {\n  type\n}\n\nfragment ContactLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  imageUrl\n}\n\nfragment ContactShowHeroTabBar_contact on Contact {\n  slug\n  canEdit\n  registrationStatus\n  invitation {\n    url\n    sentAt\n    id\n  }\n  user {\n    createdAt\n  }\n  revokeAccess\n}\n\nfragment ContainerLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n  badge {\n    ...Badge_data\n  }\n}\n\nfragment ItemImage_data on Image {\n  url\n  alt\n  highlight\n  shape\n  overlay\n  overlayIcon\n}\n\nfragment KeyField_data on KeyField {\n  label\n  value {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment LinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n  entitySlug\n  ...VoyageLinkCard_data\n  ...VesselLinkCard_data\n  ...ShipmentLinkCard_data\n  ...ContainerLinkCard_data\n  ...ContactLinkCard_data\n}\n\nfragment SemanticLine_data on SemanticLine {\n  parts {\n    key\n    ...SemanticString_data\n  }\n}\n\nfragment SemanticString_data on SemanticString {\n  text\n}\n\nfragment ShipmentLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  badge {\n    ...Badge_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  imageUrl\n}\n\nfragment ShowPageItem_data on ListItem {\n  slug\n  title\n  itemType\n  image {\n    ...ItemImage_data\n  }\n  path\n  statuses {\n    key\n    value {\n      ...SemanticString_data\n    }\n  }\n  badges {\n    key\n    ...Badge_data\n  }\n  actions {\n    key\n    ...Action_data\n  }\n  lines {\n    key\n    ...SemanticLine_data\n  }\n  keyFields {\n    key\n    ...KeyField_data\n  }\n  linkSets {\n    links {\n      key\n      type\n      ...LinkCard_data\n    }\n  }\n  stickyNoteContent\n}\n\nfragment VesselLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n}\n\nfragment VoyageLinkCard_data on Link {\n  type\n  title {\n    ...SemanticString_data\n  }\n  meta {\n    ...SemanticString_data\n  }\n  voyageEta {\n    ...SemanticString_data\n  }\n  voyageEtd {\n    ...SemanticString_data\n  }\n}\n"
  }
};
})();
(node as any).hash = '9e66ee54324ef3a1e67d74057ee437f8';
export default node;
